function CheckboxDiv({ children, id }) {
  return (
    <div id={id} style={{ display: "none", columnCount: 3 }} class="row">
      {children}
    </div>
  );
}

export default CheckboxDiv